import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import SubInvoiceModal from '../../../../Modals/SubInvoice'

import Header from './Components/Header'
import Table from './Components/Table'

const SubInvoices = props => {

  const {
    subInvoiceModal,
    componentDidMount,
    onCloseSubInvoiceModal,
  } = props

  useEffect(() => {
    componentDidMount()
  }, [])

  return (
    
    <React.Fragment>

      <Header />

      <Table />

      {subInvoiceModal.show && (
        <SubInvoiceModal
          {...subInvoiceModal}
          onClose={onCloseSubInvoiceModal}
        />
      )}

    </React.Fragment>

  )

}

SubInvoices.propTypes = {
  subInvoiceModal: PropTypes.object.isRequired,
  componentDidMount: PropTypes.func.isRequired,
  onCloseSubInvoiceModal: PropTypes.func.isRequired,
}

export default SubInvoices
